export const FETCH_PARTNER_DATA = "FETCH_PARTNER_DATA";
export const FETCH_PARTNER_DATA_SUCCESS = "FETCH_PARTNER_DATA_SUCCESS";
export const FETCH_PARTNER_DATA_FAILURE = "FETCH_PARTNER_DATA_FAILURE";
export const FETCH_FAQ_CATEGORIES = "FETCH_FAQ_CATEGORIES";
export const FETCH_FAQ_CATEGORIES_SUCCESS = "FETCH_FAQ_CATEGORIES_SUCCESS";
export const FETCH_FAQ_CATEGORIES_FAILURE = "FETCH_FAQ_CATEGORIES_FAILURE";
export const FETCH_FAQ_ARTICLE = "FETCH_FAQ_ARTICLE";
export const FETCH_FAQ_ARTICLE_SUCCESS = "FETCH_FAQ_ARTICLE_SUCCESS";
export const FETCH_FAQ_ARTICLE_FAILURE = "FETCH_FAQ_ARTICLE_FAILURE";
